import {useState} from 'react';
import useShow from '../../../hooks/useShow';
import ManageBreakPopup from '../components/manageBreakPopup/ManageBreakPopup';
import {TTimetableItem} from '../../../redux/timetable/timetable.type';

export function useBreakPopup() {
    const [currentBreak, setCurrentBreak] = useState<TTimetableItem | null>(null);
    const show = useShow();

    const handleAddBreak = () => {
        setCurrentBreak(null);
        show.open();
    };

    const handleBreakEdit = (item: TTimetableItem) => {
        setCurrentBreak(item);
        show.open();
    };

    const popup = <ManageBreakPopup show={show} breakItem={currentBreak ?? undefined} />;

    return {handleAddBreak, handleBreakEdit, popup};
}
